import React from 'react';
import PropTypes from 'prop-types';

const Overlay = ({ onClose, overlayStyle }) => {
  const handleClick = (e) => {
    if (e.target.classList.contains('overlay')) {
      onClose();
    }
  };

  return <div className="fixed inset-0 w-screen h-screen bg-black bg-opacity-30 z-[1000]"
  onClick={handleClick} style={overlayStyle}></div>;
};

Overlay.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Overlay;